import React from 'react';
import { DocumentHeader, DocumentForm, DocumentButton, LeftDiv, ButtonDiv, DropDiv } from '../styles';
import Button from '../../../../../component/button';
import { BUTTON_TYPE, ICON_BUTTON_SIZE, ICON_BUTTON_TYPE, ICON_SIZE } from '../../../../../global/constants';
import SVGIcon from '../../../../../assets/images/svg/SVGIcon';
import { Dropdown, DropdownItem } from '../../../../../component/dropdown';
import ExportSubMenu from '../exportSubMenu';
import { Divider } from '../../../../../component/dropdown/styles';
import IconButton from '../../../../../component/button/iconButton';
import DocActiveUsers from '../docActiveUsers';
import { DocData } from '../../../../../mobx/interfaces/project';
import { ActiveUser } from '../../../../../interfaces/ProjectInterface';

interface DocHeaderProps {
  docData: DocData | null;
  loading: boolean;
  isChecked: boolean;
  activeUsers: ActiveUser[];
  editorIframe: React.RefObject<HTMLIFrameElement>;
  onCancel: () => void;
  handleSave: (e: React.SyntheticEvent) => void;
  handleToggle: () => void;
  openShareModel: () => void;
  openRenameModal: () => void;
  openDeleteModel: () => void;
  openVersionHistoryModel: () => void;
  handleImportClick: () => void;
}

const DocHeader: React.FC<DocHeaderProps> = ({
  docData,
  loading,
  isChecked,
  activeUsers,
  editorIframe,
  onCancel,
  handleSave,
  handleToggle,
  openShareModel,
  openRenameModal,
  openDeleteModel,
  openVersionHistoryModel,
  handleImportClick
}) => {
  return (
    <DocumentHeader>
      <LeftDiv>
        <IconButton
          iconName='new-large-back-arrow-icon'
          size={ICON_BUTTON_SIZE.SMALL}
          variant={ICON_BUTTON_TYPE.TERTIARY}
          onClick={onCancel}
        />
        <DocumentForm>{docData?.name}</DocumentForm>
        {(docData?.id && !docData?.isBlocksuite) || (
          <Dropdown
            modalTitle='Manage Document'
            activeClassName='active'
            isMinWidth={198}
            isRemoveMaxHeight={true}
            content={
              <IconButton
                iconName='three-dots-horizontal-icon'
                size={ICON_BUTTON_SIZE.SMALL}
                variant={ICON_BUTTON_TYPE.TERTIARY}
              />
            }
            trigger='click'>
            {!docData?.isEdge && (
              <>
                <DropdownItem
                  key='full-width'
                  label='Full width'
                  iconName='full-width-icon'
                  iconSize={16}
                  iconTone='stroke'
                  isSlider={true}
                  onClick={handleToggle}
                  isChecked={isChecked}
                />
                <Divider />
              </>
            )}
            <DropdownItem
              key='rename'
              label='Rename'
              iconName='edit-icon'
              iconSize={16}
              onClick={openRenameModal}
              iconTone='fill'
              iconViewBox='0 0 18 18'
            />
            {!docData?.isEdge && (
              <>
                <DropdownItem
                  key='import'
                  label='Import'
                  iconName='download-icon'
                  iconSize={16}
                  iconViewBox='0 0 18 18'
                  onClick={handleImportClick}
                />
                <Dropdown
                  modalTitle='Export'
                  isMinWidth={166}
                  trigger='hover'
                  content={
                    <DropDiv>
                      <DropdownItem
                        label='Export'
                        iconName='upload-icon'
                        key='export'
                        iconTone='fill'
                        isSuffix={
                          <SVGIcon
                            name='updated-right-arrow-icon'
                            width={ICON_SIZE.MD}
                            height={ICON_SIZE.MD}
                            viewBox={`0 0 ${ICON_SIZE.LG} ${ICON_SIZE.LG}`}
                          />
                        }
                        justifyAlign='spaceBetween'
                      />
                    </DropDiv>
                  }>
                  <ExportSubMenu editorIframe={editorIframe} />
                </Dropdown>
              </>
            )}
            <DropdownItem
              key='version-history'
              label='View version history'
              iconName='history-icon'
              iconSize={16}
              onClick={openVersionHistoryModel}
            />
            <DropdownItem
              key='delete'
              label='Delete'
              iconName='updated-delete-icon'
              iconSize={16}
              iconViewBox='0 0 18 18'
              onClick={openDeleteModel}
              tone='critical'
            />
          </Dropdown>
        )}
      </LeftDiv>
      {docData?.id && !docData?.isBlocksuite && (
        <DocumentButton>
          <Button title='Cancel' onClick={onCancel} variant={BUTTON_TYPE.SECONDARY} buttonType='button' />
          <Button
            onClick={handleSave}
            variant={BUTTON_TYPE.PRIMARY}
            title={docData?.id ? 'Update' : 'Save'}
            isLoading={loading}
          />
        </DocumentButton>
      )}
      {(docData?.id && !docData?.isBlocksuite) || (
        <ButtonDiv>
          <DocActiveUsers users={activeUsers} />
          <Button title='Share' variant={BUTTON_TYPE.SECONDARY} onClick={openShareModel} />
        </ButtonDiv>
      )}
    </DocumentHeader>
  );
};

export default DocHeader;
